function openPage(pageName, event) {
  var i, tabcontent, tablinks;

  // 1. Hide all tab content
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // 2. Remove 'active' class from all buttons
  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // 3. Show selected tab smoothly
  const activeTab = document.getElementById(pageName);
  if (activeTab) {
    activeTab.style.display = "block";
    activeTab.classList.add("fade-in");
    setTimeout(() => activeTab.classList.remove("fade-in"), 300);
  }

  // 4. Add active class to clicked tab + update color
  if (event) {
    event.currentTarget.classList.add("active");
    const tabColor = event.currentTarget.getAttribute("data-color");
    if (tabColor) {
      document.querySelector(".just-tabs").style.backgroundColor = tabColor;
    }
  }
}

// ---
// DOCUMENT LOAD LOGIC (Fix: Only show ALL tab by default)
// ---
document.addEventListener("DOMContentLoaded", function () {
  const allTab = document.querySelector(".all-tab-btn");
  const allTabName = allTab ? allTab.getAttribute("onclick").match(/'([^']+)'/)[1] : null;

  const tabcontent = document.getElementsByClassName("tabcontent");
  const tablinks = document.getElementsByClassName("tablink");

  // Hide all tabs initially
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Remove 'active' from all buttons
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // Now show only ALL tab
  if (allTab && allTabName) {
    const allTabContent = document.getElementById(allTabName);
    if (allTabContent) {
      allTabContent.style.display = "block";
    }
    allTab.classList.add("active");

    const color = allTab.getAttribute("data-color");
    if (color) {
      document.querySelector(".just-tabs").style.backgroundColor = color;
    }
  }
});

// ---
// SEARCH BAR LOGIC
// ---
document.addEventListener("DOMContentLoaded", function () {
  const searchBtn = document.querySelector(".blog-search-btn");
  const searchBar = document.querySelector(".blog-search-bar");
  const searchInput = document.getElementById("blogSearchInput");
  const searchGo = document.getElementById("blogSearchGo");

  if (searchBtn && searchBar) {
    searchBtn.addEventListener("click", function (e) {
      e.preventDefault();
      searchBar.style.display =
        searchBar.style.display === "flex" ? "none" : "flex";
      if (searchBar.style.display === "flex") searchInput.focus();
    });
  }

  // Live filter
  if (searchInput) {
    searchInput.addEventListener("input", function () {
      const filter = searchInput.value.toLowerCase();
      const articles = document.querySelectorAll(".blog-item");

      articles.forEach(function (item) {
        const title = item.querySelector("h4").textContent.toLowerCase();
        item.style.display = title.includes(filter) ? "" : "none";
      });
    });
  }

  // Scroll to first match on Go
  if (searchGo) {
    searchGo.addEventListener("click", function () {
      const filter = searchInput.value.toLowerCase();
      if (!filter) return;

      const articles = document.querySelectorAll(".blog-item");
      for (let item of articles) {
        const title = item.querySelector("h4").textContent.toLowerCase();
        if (title.includes(filter)) {
          item.scrollIntoView({ behavior: "smooth", block: "start" });
          item.style.outline = "2px solid red";
          setTimeout(() => (item.style.outline = ""), 2000);
          break;
        }
      }
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const articleLimit = 6; // Show 6 articles first

  // Function to initialize "Load More" for each tab
  function setupLoadMore(tabSelector) {
    const tabSections = document.querySelectorAll(tabSelector);

    tabSections.forEach((tabSection) => {
      const articles = tabSection.querySelectorAll(".blog-item");
      const loadMoreBtn = tabSection.querySelector(".blog-load-more");

      if (!articles.length || !loadMoreBtn) return;

      // Hide all after 6
      if (articles.length > articleLimit) {
        articles.forEach((article, index) => {
          if (index >= articleLimit) {
            article.style.display = "none";
          }
        });

        // Handle load more click
        loadMoreBtn.addEventListener("click", function (e) {
          e.preventDefault();

          const hiddenArticles = Array.from(articles).filter(
            (item) => item.style.display === "none"
          );

          hiddenArticles.slice(0, articleLimit).forEach((item) => {
            item.style.display = "";
            item.classList.add("fade-in");
            setTimeout(() => item.classList.remove("fade-in"), 300);
          });

          // Hide button when done
          const stillHidden = Array.from(articles).some(
            (item) => item.style.display === "none"
          );
          if (!stillHidden) {
            loadMoreBtn.style.display = "none";
          }
        });
      } else {
        // Hide button if not enough articles
        loadMoreBtn.style.display = "none";
      }
    });
  }

  // Initialize for All Tab + Dynamic Tabs
  setupLoadMore("#All-Collections");
  setupLoadMore("[id^='Collection-']");
});
